import { z } from 'zod';
import superjson from 'superjson';
import { Selectable } from 'kysely';
import { CollaborationSessions, SessionStatusArrayValues } from '../../helpers/schema';

export const schema = z.object({
  id: z.string().min(1),
  name: z.string().optional(),
  description: z.string().optional(),
  status: z.enum(SessionStatusArrayValues).optional(),
  template: z.string().optional(),
  aiEnabled: z.boolean().optional(),
  aiProvider: z.string().optional(),
  aiModel: z.string().optional(),
  aiCustomEndpoint: z.string().nullable().optional(),
  allowParticipantPersonas: z.boolean().optional(),
  autoApplyRecommendations: z.boolean().optional(),
  fullAutonomousMode: z.boolean().optional(),
  skipCredentialChecks: z.boolean().optional(),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  session: Selectable<CollaborationSessions>;
};

export const updateSession = async (body: InputType, init?: RequestInit): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/sessions/update`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
